import * as React from 'react'
import { FC, useState, useRef, useCallback, MouseEventHandler } from 'react'

import './MouseFocus.scss'

interface Props {
    children?: React.ReactNode
}

interface SpotlightPosition {
    top: number
    left: number
}

const MouseFocus: FC<Props> = ({ children }) => {
    const focusStage = useRef<HTMLDivElement>(null)
    const [spotlightPosition, setSpotlightPosition] = useState<SpotlightPosition>({ left: 0, top: 0 })
    const [spotlightClass, setSpotlightClass] = useState('')

    const onMouseMoveHandle: MouseEventHandler<HTMLDivElement> = useCallback(
        (e) => {
            let stageOffset = focusStage.current?.getBoundingClientRect()
            let offsetX = stageOffset?.left ? stageOffset?.left : 0
            let offsetY = stageOffset?.top ? stageOffset?.top : 0

            setSpotlightPosition({ left: e.clientX - offsetX, top: e.clientY - offsetY })
        },
        [focusStage]
    )

    const onMouseEnterHandle: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
        setSpotlightClass('mouse-in')
    }, [])

    const onMouseLeaveHandle: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
        setSpotlightClass('mouse-out')
    }, [])

    return (
        <div
            className="MouseFocus"
            onMouseMove={onMouseMoveHandle}
            onMouseEnter={onMouseEnterHandle}
            onMouseLeave={onMouseLeaveHandle}
            ref={focusStage}
        >
            <div className="MouseFocus__stage">
                <div className={`MouseFocus__spotlight ${spotlightClass}`} style={spotlightPosition}></div>
            </div>
            {children}
        </div>
    )
}

export default MouseFocus
